import { Box, BoxProps, Typography } from '@mui/material';
import React from 'react';

import { dataUrlForClientImage } from '@/modules/hmis/hmisUtil';
import { ClientImageFragment } from '@/types/gqlTypes';

type Props = {
  client?: ClientImageFragment;
  base64?: string;
  url?: string;
  size?: number;
} & BoxProps<'img'>;

/**
 * Renders a client's profile image. If the client has no image, displays a placeholder box with the text "No Client Photo".
 */
const ClientCardImageElement: React.FC<Props> = ({
  client,
  base64,
  url,
  size = 150,
  alt,
  ...props
}) => {
  // let src = 'https://dummyimage.com/150x150/e8e8e8/aaa';
  let src;

  if (client?.image?.base64) src = dataUrlForClientImage(client.image);
  if (base64) src = `data:image/jpeg;base64,${base64}`;
  if (url) src = url;

  return (
    <Box
      {...props}
      {...(src
        ? {
            src,
            component: 'img',
            alt: alt || 'Client image',
          }
        : // Don't pass alt text to a div (invalid markup)
          { component: 'div' })}
      sx={{
        height: size,
        width: size,
        backgroundColor: (theme) => theme.palette.grey[100],
        borderRadius: (theme) => `${theme.shape.borderRadius}px`,
        ...props.sx,
      }}
    >
      {src ? undefined : (
        <Typography
          sx={{
            color: 'grayscale.main',
            borderBottom: 0,
            display: 'flex',
            flexGrow: 1,
            height: '100%',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          variant='body2'
          component='span'
        >
          No Client Photo
        </Typography>
      )}
    </Box>
  );
};

export default ClientCardImageElement;
